const RockerFoxtrot = {
    name: "Ravensburger Waltz",
    bpm: 104,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default RockerFoxtrot;